import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { PanelProperties } from "@lib/titan2/dist/game/control/properties/PanelProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Point } from "pixi.js";
import { HorizontalFixedLayout } from "../../../utils/HorizontalFixedLayout";
import { ViewProperties } from "../../../utils/ViewProperties";
import { GameFontStyle } from "../style/GameFontStyle";
import { GameStyle } from "../style/GameStyle";
export class GameWinLineCelebrationProperties extends ViewProperties {
    constructor() {
        super();
        this.mouseBlockerProperties = new MouseBlockerProperties(0x000000, 0.6, true);
        this.borderProperties = new SpriteProperties(GameStyle.GRID_BORDER_OVERLAY, GameStyle.MODULE);
        this.fireworkPanelProperties = new PanelProperties(new Point(503, 1082));
        this.fireworkSymbolSpineProperties = new SpineProperties(GameStyle.FIREWORK_SYMBOL, GameStyle.MODULE);
        this.fireworkColours = [
            0x308dd0,
            0xf7843a,
            0xceca03,
            0xe1420f,
            0xfad315,
            0xd0f249,
            0xf89105,
            0x9bc433,
            0xd3b800,
            0xdc5acf,
        ];
        this.fireworkEmitterProperties = {
            emit: false,
            autoUpdate: true,
            frequency: 0.001,
            maxParticles: 1000,
            pos: { x: 0, y: 0 },
            lifetime: { min: 0.6, max: 0.6 },
            behaviors: [
                {
                    type: "scale",
                    config: {
                        scale: {
                            list: [{ value: 1, time: 0 }, { value: 0, time: 1 }],
                            isStepped: false
                        },
                        minMult: 0.1
                    }
                },
                {
                    type: "textureRandom",
                    config: {
                        textures: [
                            "Game-Particle"
                        ]
                    }
                },
                {
                    type: "rotationStatic",
                    config: {
                        min: 0,
                        max: 360,
                    }
                },
                {
                    type: "moveAcceleration",
                    config: {
                        accel: {
                            x: 0,
                            y: 180,
                        },
                        minStart: 0,
                        maxStart: 50,
                        rotate: true,
                    }
                },
            ],
        };
        this.fireworkGlowDistance = 15;
        this.fireworkGlowStrength = 5;
        this.lineBorderProperties = new SpriteProperties(GameStyle.WIN_LINE_BORDER, GameStyle.MODULE, new Point(503, 870), undefined, new Point(0.5, 0.5));
        this.linePanelProperties = new PanelProperties(new Point(315, 870));
        this.lineSymbolSpineProperties = new SpineProperties(GameStyle.TICKET_SYMBOL, GameStyle.MODULE, undefined, new Point(0.8, 0.8));
        this.multiplierTextProperties = new TextFieldProperties(GameFontStyle.WIN_LINE_MULTIPLIER, new Point(503, 976), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(900, 208));
        this.amountTextProperties = new TextFieldProperties(GameFontStyle.WIN_LINE_AMOUNT, new Point(726, 805), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(356, 128));
        this.fireworkDistanceMin = 800;
        this.fireworkDistanceMax = 900;
        this.fireworkSlantMin = 130;
        this.fireworkSlantMax = 140;
        this.fireworkPanelProperties.layout = new HorizontalFixedLayout(85, ControlConstants.CENTER);
        this.linePanelProperties.layout = new HorizontalFixedLayout(70, ControlConstants.CENTER);
    }
}
//# sourceMappingURL=GameWinLineCelebrationProperties.js.map